import React, { useRef } from 'react';
import { components } from 'react-select';
import ReactSelect from 'react-select';

// Custom ValueContainer (your existing one)
function CustomValueContainer({ children, ...props }) {
  const { getValue, hasValue, isMulti, selectProps: { inputValue } } = props;
  const numberOfValues = getValue().length;
  const value = getValue();
  const child = children;

  if (!hasValue || !isMulti) {
    return <components.ValueContainer {...props}>{children}</components.ValueContainer>;
  }

  return (
    <components.ValueContainer {...props}>
      {!inputValue && (
        <div
          style={{ backgroundColor: '#EAEAEA', padding: '.15rem', marginRight: '8px' }}
          className='rounded text-muted small px-2'
        >
          {numberOfValues === 1 && value[0]?.label === 'All'
            ? 'Selected all'
            : `${numberOfValues} Selected`}
        </div>
      )}
      {child.length > 0 && child[1]}
    </components.ValueContainer>
  );
}

// Custom Option component to show checkbox
const CustomOption = (props) => {
  const { isSelected, label } = props;
  return (
    <components.Option {...props}>
      <input
        type="checkbox"
        checked={isSelected}
        onChange={() => null}
        style={{ marginRight: 8 }}
      />
      {label}
    </components.Option>
  );
};

function ReactMultiSelect(props) {
  const {
    value = [],
    options = [],
    OptionLabel = 'label',
    ValueLabel = 'value',
    SelectAllText = 'All',
    noOptionsMessage='No options',
    onChange,
    getOptionLabel,
    getOptionValue,
    placeholder,
    hasError,
    showSelectAll = true,
  } = props;

  const valueRef = useRef(value);
  valueRef.current = value;

  const inputRef = useRef(null);

  const selectAllOption = { [OptionLabel]: SelectAllText, [ValueLabel]: '-' };

  // const isSelectAllSelected = () =>
  //   valueRef.current.length > 0 && valueRef.current.length === options.length;
  const isSelectAllSelected = () =>
    showSelectAll && valueRef.current.length > 0 && valueRef.current.length === options.length;

  // const isOptionSelected = (option) =>
  //   valueRef.current.some((val) => val?.[ValueLabel] === option?.[ValueLabel]) || isSelectAllSelected();
  const isOptionSelected = (option) => valueRef.current.some((val) => val?.[ValueLabel] === option?.[ValueLabel]) || (showSelectAll && isSelectAllSelected());

  // const getOptions = () => (options.length === 0 ? [] : [selectAllOption, ...options]);
  const getOptions = () => options.length === 0 ? [] : showSelectAll ? [selectAllOption, ...options] : options;

  // const getValue = () => (isSelectAllSelected() ? [selectAllOption] : value);
   const getValue = () => showSelectAll && isSelectAllSelected() ? [selectAllOption] : value;

  // const handleChange = (newValue, actionMeta) => {
  //   const { action, option, removedValue } = actionMeta;
  //   const optionValue = option?.[ValueLabel];
  //   const optionLabel = option?.[OptionLabel];
  //   const removedValueId = removedValue?.[ValueLabel];

  //   if (action === 'select-option' && optionValue === selectAllOption[ValueLabel]) {
  //     onChange && onChange(options, actionMeta);
  //   } else if (
  //     (action === 'deselect-option' && optionValue === selectAllOption[ValueLabel]) ||
  //     (action === 'remove-value' && removedValueId === selectAllOption[ValueLabel])
  //   ) {
  //     onChange && onChange([], actionMeta);
  //   } else if (
  //     action === 'deselect-option' &&
  //     optionLabel !== selectAllOption[OptionLabel]
  //   ) {
  //     onChange &&
  //       onChange(
  //         valueRef.current.filter((val) => val?.[ValueLabel] !== optionValue),
  //         actionMeta
  //       );
  //   } else {
  //     onChange && onChange(newValue || [], actionMeta);
  //   }
  // };

   const handleChange = (newValue, actionMeta) => {
    const { action, option, removedValue } = actionMeta;
    const optionValue = option?.[ValueLabel];
    const optionLabel = option?.[OptionLabel];
    const removedValueId = removedValue?.[ValueLabel];

    if (showSelectAll) {
      if (action === 'select-option' && optionValue === selectAllOption[ValueLabel]) {
        onChange && onChange(options, actionMeta);
        return;
      } else if (
        (action === 'deselect-option' && optionValue === selectAllOption[ValueLabel]) ||
        (action === 'remove-value' && removedValueId === selectAllOption[ValueLabel])
      ) {
        onChange && onChange([], actionMeta);
        return;
      }
    }

    if (action === 'deselect-option' && optionLabel !== SelectAllText) {
      onChange &&
        onChange(
          valueRef.current.filter((val) => val?.[ValueLabel] !== optionValue),
          actionMeta
        );
    } else {
      onChange && onChange(newValue || [], actionMeta);
    }
  };

  const closeMenu = React.useCallback(() => {
    if (inputRef.current) inputRef.current.onMenuClose?.();
  }, []);

  return (
    <div tabIndex={0} onBlur={closeMenu}>
      <ReactSelect
        ref={inputRef}
        styles={{
          menuPortal: (base) => ({ ...base, zIndex: 9999 }),
          control: (provided) => ({
            ...provided,
            border: hasError ? '1px solid red' : '1px solid #ced4da',
            boxShadow: 'none',
            '&:hover': { border: '1px solid #ced4da' },
            minHeight: '38px',
            fontSize: '14px',
          }),
          placeholder: (provided) => ({ ...provided, color: '#6c757d' }),
          singleValue: (provided) => ({ ...provided, color: '#495057' }),
        }}
        isOptionSelected={isOptionSelected}
        options={getOptions()}
        value={getValue()}
        onChange={handleChange}
        hideSelectedOptions={false}
        closeMenuOnSelect={false}
        getOptionLabel={getOptionLabel}
        getOptionValue={getOptionValue}
        isMulti
        placeholder={placeholder}
        components={{
          ValueContainer: CustomValueContainer,
          DropdownIndicator: () => null,
          IndicatorSeparator: () => null,
          Option: CustomOption, // Add checkbox here
        }}
        onBlur={closeMenu}
        menuPortalTarget={document.body}
        noOptionsMessage={() => noOptionsMessage}
      />
    </div>
  );
}

export default ReactMultiSelect;